class WIwishList extends HTMLElement{
    constructor() {
        super();
    }
    connectedCallback() {
        this.productHandleToLocal();
        this.productHandleRemove();
        this.productWishPreload();
        this.wishlistcount();
        document.addEventListener("loadWishlistIncollection", ()=>{this.collectionWishPreload();});
    }
    // Adding product handle to localstorage
    productHandleToLocal() {
        let wishListCon = this.querySelector('.WI_wishlist_con');
        wishListCon.addEventListener('click', (e)=>{
            e.preventDefault();
            let productDatahabdle = wishListCon.getAttribute('data-producthandel');
            let oldLocalData = JSON.parse(localStorage.getItem('productHandleArray')) || [];
            oldLocalData.push(productDatahabdle);
            requestAnimationFrame(()=> {
            localStorage.setItem('productHandleArray', JSON.stringify(oldLocalData));
            setTimeout(() => {
                this.wishlistcount();
            }, 100);
            wishListCon.style.display = 'none';
            wishListCon.nextElementSibling.style.display = 'flex';
            });
        })
    };
    // Removing product handle from localstorage
    productHandleRemove() {
        let wishListRemove = this.querySelector('.WI_wishlist_fill_con');
        wishListRemove.addEventListener('click', (e)=>{
            e.preventDefault();
            let productRemoveHandle = wishListRemove.getAttribute('data-producthandel');
            let localWishData = JSON.parse(localStorage.getItem('productHandleArray'));
            if (localWishData.includes(productRemoveHandle)) {
                localWishData.splice(localWishData.indexOf(productRemoveHandle), 1);
            }
            requestAnimationFrame(() => {
                localStorage.setItem('productHandleArray', JSON.stringify(localWishData));
                setTimeout(() => {
                    this.wishlistcount();
                }, 100);
                wishListRemove.style.display = 'none';
                wishListRemove.previousElementSibling.style.display = 'flex';
        });
        })
    }
    // Preload all the product which is stored
    productWishPreload() {
        window.addEventListener("load", function() {
            if (localStorage.getItem('productHandleArray') !== null) {
                var allwishlist = JSON.parse(localStorage.getItem('productHandleArray'));
                for (let i = 0; i < allwishlist.length; i++) {
                    var wish = "wish_" + allwishlist[i];
                    var wish_remove = "wish_remove_" + allwishlist[i];
                    var wishElement = document.getElementById(wish);
                    var wishElementclass = document.querySelectorAll("."+wish);
                    var wishRemoveElement = document.getElementById(wish_remove);
                    var wishRemoveElementclass = document.querySelectorAll("."+wish_remove);
                    if (wishElement && wishRemoveElement) {
                        // wishElement.style.display = "none";
                        // wishRemoveElement.style.display = "flex";
                        wishElementclass.forEach(wIsh=>{
                            wIsh.style.display = "none";
                        })
                        wishRemoveElementclass.forEach(wIshR=>{
                            wIshR.style.display = "flex";
                        })
                    } else {
                        
                    }
                }
            }
        });
        };

        // Preloader for collection filtering or infinity srcoll
        collectionWishPreload() {
                if (localStorage.getItem('productHandleArray') !== null) {
                    var allwishlist = JSON.parse(localStorage.getItem('productHandleArray'));
                    for (let i = 0; i < allwishlist.length; i++) {
                        var wish = "wish_" + allwishlist[i];
                        var wish_remove = "wish_remove_" + allwishlist[i];
                        var wishElement = document.getElementById(wish);
                        var wishElementclass = document.querySelectorAll("."+wish);
                        var wishRemoveElement = document.getElementById(wish_remove);
                        var wishRemoveElementclass = document.querySelectorAll("."+wish_remove);
                        if (wishElement && wishRemoveElement) {
                            // wishElement.style.display = "none";
                            // wishRemoveElement.style.display = "flex";
                            wishElementclass.forEach(wIsh=>{
                                wIsh.style.display = "none";
                            })
                            wishRemoveElementclass.forEach(wIshR=>{
                                wIshR.style.display = "flex";
                            })
                        } else {
                            
                        }
                    }
                }
            };

        wishlistcount() {
            let dataForCount = JSON.parse(localStorage.getItem('productHandleArray'));
            if (dataForCount == null || dataForCount.length == 0) {
                document.querySelectorAll('.WI_wishListCount').forEach(e => {e.style.display = "none"});
            }else{
                document.querySelectorAll('.WI_wishListCount').forEach(e => {e.style.display = "block"});
                document.querySelectorAll('.WI_wishListCount').forEach(e => {e.innerHTML = dataForCount.length;});
            }
        }
}
customElements.define('wi-wishlist', WIwishList);